import { getModelSchema } from '../api/getDefaultModelSchema';
import { deserializePropsWithSchema } from './deserialize';
import { DeserializeObjectContext } from '../context/DeserializeObjectContext';
export function update(target, ser, deserializeOptions = {}) {
    const modelSchema = getModelSchema(target);
    if (!modelSchema)
        throw 'update failed to determine schema';
    const context = new DeserializeObjectContext({ modelSchema, ser, deserializeOptions, target, parentContext: null });
    deserializePropsWithSchema(context, modelSchema, ser, target);
    return target;
}
